import { Combobox } from '@base-ui/react/combobox';
import { useId } from 'react';
import { Close, Search } from '#icons';
import { useDropdownContext } from '../../context/DropdownContext';
import { styles } from './styles';

export function DropdownSearch() {
  const id = useId();
  const { label, searchPlaceholder, searchTerm, searchClearLabel, setSearchTerm, dataTestId } =
    useDropdownContext();
  const hasSearchTerm = searchTerm.trim().length > 0;

  return (
    <div css={styles.Container}>
      <Combobox.InputGroup css={styles.InputGroup}>
        <Combobox.Input
          id={id}
          aria-label={label}
          placeholder={searchPlaceholder}
          css={styles.Input}
        />
        <div css={styles.SearchIcon}>
          <Search />
        </div>
        {hasSearchTerm ? (
          <button
            type="button"
            css={styles.ClearButton}
            aria-label={searchClearLabel}
            data-testid={dataTestId ? `${dataTestId}-clear-search-button` : undefined}
            onMouseDown={(event) => {
              event.preventDefault();
            }}
            onClick={() => {
              setSearchTerm('');
            }}
          >
            <Close />
          </button>
        ) : null}
      </Combobox.InputGroup>
    </div>
  );
}
